var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59189 0.210936L9.75513 3.77646C9.83276 3.84295 9.89434 3.92188 9.93636 4.00875C9.97837 4.09562 10 4.18873 10 4.28276C10 4.47266 9.91192 4.65478 9.75513 4.78906C9.67749 4.85555 9.58532 4.9083 9.48389 4.94428C9.38246 4.98026 9.27374 4.99878 9.16395 4.99878C8.94221 4.99878 8.72956 4.92335 8.57277 4.78906L5.00071 1.72272L1.42865 4.78906C1.35125 4.8559 1.25916 4.90895 1.15769 4.94516C1.05623 4.98136 0.947394 5 0.837475 5C0.727555 5 0.618724 4.98136 0.517258 4.94516C0.415792 4.90895 0.323701 4.8559 0.246296 4.78906C0.168253 4.72277 0.106308 4.6439 0.0640354 4.557C0.0217628 4.47011 0 4.3769 0 4.28276C0 4.18862 0.0217628 4.09542 0.0640354 4.00852C0.106308 3.92162 0.168253 3.84275 0.246296 3.77646L4.40953 0.210936C4.48694 0.144098 4.57903 0.0910459 4.68049 0.0548425C4.78196 0.0186391 4.89079 0 5.00071 0C5.11063 0 5.21946 0.0186391 5.32093 0.0548425C5.42239 0.0910459 5.51448 0.144098 5.59189 0.210936Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDark);
export default __webpack_public_path__ + "static/media/arrow_up_dark.f97f7cbca1710991f9d4f27fc753b287.svg";
export { ForwardRef as ReactComponent };